module.exports = __webpack_public_path__ + "img/inspectionicon.5adea8ef.svg";